import React from "react";
import { NavLink } from "react-router-dom";

import {
  HiOutlineArrowsUpDown,
  HiOutlineChartBar,
  HiOutlinePresentationChartLine,
  HiOutlineClock,
  HiOutlineChatBubbleLeftRight,
} from "react-icons/hi2";

import "./ForexBottomNav.css";

const ForexBottomNav = () => {
  return (
    <nav className="forex-bottom-nav">

      {/* QUOTES */}
      <NavLink
        to="/forex"
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >                                                                                                                                            
        <HiOutlineArrowsUpDown className="nav-icon" />
        <span>Quotes</span>
      </NavLink>

      {/* CHARTS */}
      <NavLink
        to="/charts"
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >
        <HiOutlineChartBar className="nav-icon" />
        <span>Charts</span>
      </NavLink>

      {/* TRADE */}
      <NavLink
        to="/trader"
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >
        <HiOutlinePresentationChartLine className="nav-icon" />
        <span>Trade</span>
      </NavLink>

      {/* HISTORY */}
      <NavLink
        to="/Forex-History"
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >
        <HiOutlineClock className="nav-icon" />
        <span>History</span>
      </NavLink>

      {/* MESSAGES */}
      <NavLink
        to="/messages"
        className={({ isActive }) =>
          isActive ? "nav-item active" : "nav-item"
        }
      >
        <HiOutlineChatBubbleLeftRight className="nav-icon" />
        <span>Messages</span>
      </NavLink>

    </nav>
  );
};

export default ForexBottomNav;